import styled from 'styled-components'

export const SearchSplit = styled.div``
